import hasImageUploadCare from '@/app/utils/hasImageUploadCare';

/**
 * Hàm chỉnh sửa quality của Image
 * Hiện tại chỉ có uploadcare hỗ trợ nên nếu k phải uploadcare thì trả về src ban đầu
 * @param src source image
 * @param quality lighter | lightest hoặc xem thêm ở đây https://uploadcare.com/docs/transformations/image/compression/#operation-quality
 * @returns new source image with quality
 */
export default (src: string, quality: string): string => {
  //nếu source lỗi hoặc k phải upload care thì không làm gì
  if (!src || !quality || !hasImageUploadCare(src)) {
    return src;
  }

  //kiểm tra xem có quality trước đó không nếu k có quality thì không làm gì cả vì uploadcare có vài trường hợp sẽ k có quality
  const operations = src.split('-/');

  if (operations && operations.length) {
    operations.forEach((item, index) => {
      if (!item) return;

      let newItem = item;
      const kvArr = item.split('/'); //chia ra key/value bằng dấu /
      if (kvArr && kvArr[0] && kvArr[1] && kvArr[0] == 'quality') {
        kvArr[1] = quality; //đổi giá trị của quality sau đó gắn lại
        newItem = kvArr.join('/');
      }
      operations[index] = newItem;
    });
    return operations.join('-/');
  }

  return src;
};
